/**
 * Progress through the refine wizard. `describing` and `generating` are
 * transient states that auto-advance on completion.
 */
export type RefineStep =
  | 'intent'
  | 'describing'
  | 'review'
  | 'references'
  | 'generating'
  | 'compare';

/**
 * All mutable state for a single refinement flow. Kept in one object so
 * the modal can invalidate downstream data (description → edited → candidate)
 * whenever the user goes back and edits something upstream.
 */
export interface RefinementSession {
  intent: string;
  /** Original JSON description as returned by describe-image. */
  currentDescription: string | null;
  /** Updated JSON as returned by modify-description. */
  aiUpdatedDescription: string | null;
  /** User-edited version of aiUpdatedDescription (source of truth for step 4+). */
  editedDescription: string | null;
  /** Story element IDs picked for extra refs (≤ 5). */
  selectedElementIds: string[];
  /** How many alternatives to generate in parallel (1–3). */
  variantCount: number;
  /** R2 key + URL of the pending candidate image, if any. */
  candidateR2Key: string | null;
  candidateImageUrl: string | null;
}

export function emptySession(): RefinementSession {
  return {
    intent: '',
    currentDescription: null,
    aiUpdatedDescription: null,
    editedDescription: null,
    selectedElementIds: [],
    variantCount: 3,
    candidateR2Key: null,
    candidateImageUrl: null,
  };
}
